import GpsPlanEntryRecordsResponse, {
  GpsPlanEntryRecordsResponseData,
  GpsPlanEntryRecordsResponseItem,
} from "../../../api/raily/gps/plan-entry-records/gps-plan-entry-records-response";
import GpsPlanEntryRecords, {
  GpsPlanEntryRecordsItem,
} from "./gps-plan-entry-records";

const createDataItem = (
  responseItem: GpsPlanEntryRecordsResponseItem,
): GpsPlanEntryRecordsItem => {
  return {
    latitude: responseItem.lat,
    longitude: responseItem.lon,
    recordTime: new Date(responseItem.recordTime),
  };
};

const createData = (
  responseData: GpsPlanEntryRecordsResponseData,
): GpsPlanEntryRecordsItem[] => {
  return responseData.map(createDataItem);
};

const create = (response: GpsPlanEntryRecordsResponse): GpsPlanEntryRecords => {
  return {
    data: createData(response.data),
  };
};

const gpsPlanEntryRecordsFactory = {
  create,
};

export default gpsPlanEntryRecordsFactory;
